import React from 'react';
import './ReschedulePopup.css';
import { ErrorMessage, Form, Formik } from 'formik';
import * as Yup from 'yup'
import { DOB } from '@custom/Hospital/schema';
import { TIME } from '@custom/Utils/schema/schema';

function ReschedulePopup({ date, time, setUpdatedDateTime, onConfirm, onCancel, isOpen }) {
  if (!isOpen) return null;

  let initialValues = {
    date: '',
    time: ''
  }

  const _schema = Yup.object().shape({
    date: Yup.date().required("Date is required."),
    time: Yup.string().required(TIME.validation.required),
  });

  return (
    <div className="popup-overlay fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center">
      <div className="popup-container w-[30rem] bg-white p-6 rounded-lg shadow-lg">
        <div className="flex justify-between border-b pb-4">
          <h2 className="popup-heading-text">Reschedule Appointment</h2>
          <div className="text-xl cursor-pointer" onClick={onCancel}>X</div>
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={_schema}
          onSubmit={() => { onConfirm() }}
        >
          {({
            errors,
            values,
            handleChange,
            handleBlur,
            touched,
            setFieldValue,
            setFieldTouched,
          }) => (
            <Form >

              <div className="mt-4">
                <div className="text-start mb-2">
                  <p className="text-left span-text"><span className='span-heading'>Current Date: </span>{date}</p>
                  <p className="mt-2 text-left span-text"><span className="span-heading">Current Time: </span>{time}</p>
                </div>
                <div className="flex flex-col mb-6">
                  <label className='mt-3 text-left' htmlFor="date">Date</label>
                  <input
                    type="date"
                    name="date"
                    id="date"
                    className="p-2 border rounded"
                    onChange={(e) => {
                      handleChange(e)
                      setUpdatedDateTime((prev) => ({ ...prev, date: e.target.value }))
                    }}
                    onBlur={handleBlur}
                    onKeyDown={(e) => e.preventDefault()}
                  />
                  <ErrorMessage name="date" component="div" className="error text-error text-left" />

                  <label className='mt-5 text-left' htmlFor="time">Time</label>
                  <input
                    type="time"
                    name="time"
                    id="time"
                    className="p-2 border rounded"
                    onChange={(e) => {
                      handleChange(e)
                      setUpdatedDateTime((prev) => ({ ...prev, time: `${prev?.date}T${e.target.value}:00` }))
                    }}
                    onBlur={handleBlur}
                  />
                  <ErrorMessage name="time" component="div" className="error text-error text-left" />

                </div>
                <div className="popup-actions flex justify-end gap-4">
                  <button className="custom-button" onClick={onCancel}>Cancel</button>
                  <button type="submit" className="custom-button main-theme">Save</button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default ReschedulePopup;
